// unlike __types__/AdvancedSearchCQLQuery.ts, this file is not autogenerated
// as the AGG client in CFE isn't set up yet to autogenerate types

import type { ExperimentLayer } from '@atlassian/search-client';

export enum AdvancedAGGSearchQueryFilterRangeField {
	LASTMODIFIED = 'LASTMODIFIED',
}

export interface AdvancedAggSearchQueryFilterRange {
	field: AdvancedAGGSearchQueryFilterRangeField;
	gt?: string | null;
	lt?: string | null;
}

export interface AdvancedAGGSearchQueryConfluenceFilters {
	spacesFilter?: string[];
	contributorsFilter?: string[];
	labelsFilter?: string[];
	ancestorIdsFilter?: string[];
	range?: AdvancedAggSearchQueryFilterRange;
	titleMatchOnly?: boolean;
	containerStatus?: string[];
	contentStatuses?: string[];
	creatorsFilter?: string[];
	isVerified?: boolean;
}

export interface AdvancedAGGSearchQueryFilters {
	entities: string[];
	locations: string[];
	confluenceFilters: AdvancedAGGSearchQueryConfluenceFilters;
}

export interface AdvancedAGGSearchAnalytics {
	searchSessionId: string | null;
}

export interface AdvancedAGGSearchQueryVariables {
	experience: string;
	analytics: AdvancedAGGSearchAnalytics;
	query: string | string[];
	first: number;
	after?: string;
	filters: AdvancedAGGSearchQueryFilters;
	experimentContext: {
		experimentId?: string;
		shadowExperimentId?: string;
		experimentLayers?: ExperimentLayer[];
	};
	isLivePagesEnabled?: boolean;
}

export enum SearchResultType {
	page = 'page',
	blogpost = 'blogpost',
	space = 'space',
	attachment = 'attachment',
	comment = 'comment',
	board = 'board',
	filter = 'filter',
	issue = 'issue',
	plan = 'plan',
	project = 'project',
	unrecognised = 'unrecognised',
}

export enum ConfluenceContentType {
	ATTACHMENT = 'ATTACHMENT',
	BLOG_POST = 'BLOG_POST',
	COMMENT = 'COMMENT',
	PAGE = 'PAGE',
}

export enum ConfluenceSpaceStatus {
	ARCHIVED = 'ARCHIVED',
	CURRENT = 'CURRENT',
}

export enum ConfluenceSpaceType {
	GLOBAL = 'GLOBAL',
	PERSONAL = 'PERSONAL',
}

export interface AdvancedAGGSearchQueryNodeConfluenceEntityAncestorLinks {
	webUi: string | null;
}

export interface AdvancedAGGSearchQueryNodeConfluenceEntityAncestor {
	title: string;
	id: string;
	links: AdvancedAGGSearchQueryNodeConfluenceEntityAncestorLinks | null;
}

export interface AdvancedAGGSearchQueryNodeConfluenceEntityMetadataTitleEmojiPublished {
	id: string | null;
	value: string | null;
	key: string | null;
}

export interface AdvancedAGGSearchQueryNodeConfluenceEntityMetadata {
	titleEmojiPublished: AdvancedAGGSearchQueryNodeConfluenceEntityMetadataTitleEmojiPublished | null;
}

export interface AdvancedAGGSearchQueryNodeConfluenceEntity {
	id?: string;
	type?: ConfluenceContentType | null;
	subtype?: string | null;
	ancestors?: (AdvancedAGGSearchQueryNodeConfluenceEntityAncestor | null)[] | null;
	metadata?: AdvancedAGGSearchQueryNodeConfluenceEntityMetadata | null;
}

export interface AdvancedAGGSearchQueryNodeSpaceEntityIcon {
	path: string | null;
}

export interface AdvancedAGGSearchQueryNodeSpaceEntityLinks {
	webUi: string | null;
}

export interface AdvancedAGGSearchQueryNodeSpace {
	id: string;
	spaceId: string | null;
	name: string | null;
	key: string | null;
	webUiLink: string | null;
}

export interface AdvancedAGGSearchQueryNode {
	id: string;
	entityId: string;
	title: string;
	type: SearchResultType;
	url: string;
	lastModified?: string | null;
	isVerified?: boolean;
	excerpt?: string | null;
	key?: string | null;
	iconPath?: string | null;
	webUiLink?: string | null;
	confluenceEntity?: AdvancedAGGSearchQueryNodeConfluenceEntity | null;
	space?: AdvancedAGGSearchQueryNodeSpace | null;
}

export interface AdvancedAGGSearchQueryEdges {
	node: AdvancedAGGSearchQueryNode | null;
}

export interface AdvancedAGGSearchQueryPageInfo {
	endCursor: string | null;
}

export interface AdvancedAGGSearchQueryAbTest {
	abTestId: string | null;
	controlId: string | null;
	experimentId: string | null;
}

export interface AdvancedAGGSearchQueryInnerSearch {
	edges: AdvancedAGGSearchQueryEdges[];
	pageInfo: AdvancedAGGSearchQueryPageInfo;
	totalCount: number | null;
	abTest: AdvancedAGGSearchQueryAbTest | null;
}

export interface AdvancedAGGSearchQuerySearch {
	search: AdvancedAGGSearchQueryInnerSearch | null;
}

export interface AdvancedAGGSearchQuery {
	search: AdvancedAGGSearchQuerySearch | null;
}
